<template>
  <el-row>
    <el-col>
      <rabbey-table3
        :columns="columns"
        :data="Item"
        :summary-method="getSummaries"
        show-summary
        default-expand-all
        stripe
      ></rabbey-table3>
    </el-col>
    <el-button type="primary" icon="el-icon-download" @click="exportReport"
      >Exportar</el-button
    >
  </el-row>
</template>

<script>
import flow from "lodash/fp/flow";
import map from "lodash/fp/map";
import groupBy from "lodash/fp/groupBy";
import { exportExcel } from "@/helpers/exportExcel";

export default {
  name: "DifNavisionNavixyReport",
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    items: Array
  },

  data() {
    return {
      Item: [],
      columns: [
        {
          prop: "CustomerCode",
          label: "Código Cliente",
          width: 155,
          fixed: true
        },
        {
          prop: "CustomerName",
          label: "Nombre Cliente",
          minWidth: 150,
          fixed: true,
          sortable: true
        },
        {
          prop: "ContractNumber",
          label: "Número Contrato",
          minWidth: 150,
          fixed: true,
          sortable: true
        },
        {
          prop: "NavixyUserCode",
          label: "Código Navixy",
          minWidth: 150,
          fixed: true,
          sortable: true
        },
        {
          prop: "ContractLineQty",
          label: "Qty Lineas Navision",
          minWidth: 150,
          sortable: true
        },
        {
          prop: "TrackerQty",
          label: "Qty Lineas Navixy",
          minWidth: 150,
          sortable: true
        },
        {
          prop: "Difference",
          label: "Diferencia",
          minWidth: 150,
          sortable: true
        },
        {
          prop: "Comment",
          label: "Comentario",
          minWidth: 180,
          sortable: true
        }
      ],
      dataItems: []
    };
  },
  created() {
    this.getReport();
  },
  methods: {
    getReport() {
      this.loading = true;
      this.$http
        .get("/api/navixy/GetReportDiffNavixyVsNavision", {
          timeout: 3 * 60 * 1000
        })
        .then((resp) => {
          const { details } = resp.data;

          this.Item = details;
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.property === "Difference") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return Math.abs(prev) + Math.abs(curr);
            } else {
              return prev;
            }
          }, 0);
        } else if (
          column.property === "ContractLineQty" ||
          column.property === "TrackerQty"
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    async exportReport() {
      this.dataItems = this.Item;
      await exportExcel(
        this.columns.map((column) => {
          return column.label;
        }),
        this.dataItems.map((data) => {
          return [
            data.CustomerCode,
            data.CustomerName,
            data.ContractNumber,
            data.NavixyUserCode,
            data.ContractLineQty,
            data.TrackerQty,
            data.Difference,
            data.Comment
          ];
        }),
        "Lista de Diferencia de equipos entre Navision y Navixy"
      );
    }
  },
  computed: {
    itemsRender() {
      const items = flow(
        groupBy("CustomerCode"),
        map((records) => {
          const firstRecord = records[0];
          records.splice(0, 1);

          return {
            ...firstRecord,
            children: records
          };
        })
      )(this.items);
      return items;
    }
  }
};
</script>

<style lang="scss" scoped>
.tags span:not(:first-child) {
  margin-left: 5px;
}
.el-table .warning-row {
  background: red;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
